import { useFilterJobTitleContext } from "./filter-job-title.context";

export function FilterJobTitle() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterJobTitleContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}